import './SampleFilter.css';
import PropTypes from 'prop-types'

export default function TextFilter({filter}) {

  return (
    <p>
      Filter contents for {filter.name}
    </p>
  );
}

TextFilter.propTypes = {
  filter: PropTypes.any
}
